// BFF apps-platform-backend response types (app-local — promote a @crm/types si 2+ apps consume).

export type UUID = string

// ─── /auth/* ────────────────────────────────────────────────────────────

export type LoginRequest = {
  email: string
  password: string
}

export type LoginResponse = {
  user_id: UUID
  email: string
  tenant_id: string // "" (empty) si super_admin
  roles: string[]
}

export type MeResponse = LoginResponse

// ─── /tenants/* ─────────────────────────────────────────────────────────

export type TenantMetadata = {
  id: UUID
  client_id: UUID | null
  name: string
  bandeja_app: string
  default_sapp: string | null
  config_overrides: Record<string, unknown>
  status: string
}

export type TenantSapp = {
  sapp_slug: string
  enabled: boolean
  config: Record<string, unknown>
  config_override: Record<string, unknown>
  meta_flow_id: string | null
  // Joined from catalog
  name: string
  description: string
  vertical: string
  version: string
}

export type SappToggleResponse = {
  tenant_id: UUID
  sapp_slug: string
  enabled: boolean
  platform_updated: boolean
  legacy_updated: boolean
  legacy_sessions_reset: number | null
  legacy_error: string | null
  cache_invalidated: boolean
}

export type HealthCardResponse = {
  tenant_id: UUID
  name: string
  bandeja_app: string
  default_sapp: string | null
  client_id: UUID | null
  client_name: string | null
  sapps_enabled: number
  sapps_total: number
  sapps_enabled_slugs: string[]
  status: string
}

// ─── Tenants prod conocidos (hardcoded MVP — futuro: Core API expone /platform/tenants list) ─

export const KNOWN_TENANTS: Array<{ id: UUID; label: string }> = [
  { id: '5613e900-b6d8-43d4-b445-288992ec87e3', label: 'InGenios Gateway Prod' },
  { id: 'e07d5676-6f4d-4579-8b3e-2f6779bac2bc', label: 'Piloto Coexistence Mapro Test' },
]
